export * from './phoneme-learn.component';